import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  toggleUnifyText,
  setLatestFont,
  updateUnifiedFont,
  updateUnifiedFontSize,
  setLatestFontSize,
} from "../../../actions";
import CheckmarkIcon from "../../Layout/Icons/CheckmarkIcon";
import SelectTypeface from "./SelectTypeface";
import TextSize from "./TextSize";
import DefaultFont from "./DefaultFont";

class UnifyText extends React.Component {
  state = {
    dropdownActive: false,
  };

  handleFontChange = (font) => {
    this.props.setLatestFont({ font });
    this.props.updateUnifiedFont({ font });
  };

  toggleDropdown = () => {
    // Display or hide the options list when value is clicked
    this.setState((prevState) => {
      return { dropdownActive: !prevState.dropdownActive };
    });
  };

  selectOption = (value) => {
    this.handleFontChange(value);
    this.toggleDropdown();
  };

  handleToggleUnifyText = (selectedFont) => {
    // Update fonts for all text elements when initially enabling unify text
    if (this.props.unifyText) {
      this.props.toggleUnifyText(false);
    } else {
      this.props.toggleUnifyText(true);
      this.props.setLatestFont({ font: selectedFont });
      this.props.updateUnifiedFont({ font: selectedFont });
      this.props.updateUnifiedFontSize({ value: selectedFont.size });
    }
  };

  onUpdateSize = (value) => {
    this.props.setLatestFontSize({ value });
    this.props.updateUnifiedFontSize({ value });
  };

  closeDropdown = () => {
    this.setState({
      dropdownActive: false,
    });
  };

  render() {
    const active = this.props.unifyText ? "active" : "inactive",
      fontSizes = this.props.productOption
        ? this.props.productOption.font_sizes
        : null,
      allowed_font_categories = this.props.fonts.allowed_font_categories,
      fontCategoriesArray = [];

    const layersWithText = this.props.layers.filter((obj) => {
      return obj.allow_text;
    });

    layersWithText.forEach((layer) => {
      const filterFontCategories = Object.values(
        this.props.fonts.categories,
      ).filter((category) => {
        //check for special layer font restrictions
        if (layer.is_applique) {
          if (layer.character_type.length === 0) {
            //if no character type is specified, show all
            return category.is_applique;
          }
          return (
            category.is_applique &&
            layer.character_type.indexOf(category.character_type) !== -1
          );
        } else if (layer.is_repousse) {
          return category.is_foil_and_embossed;
        } else if (layer.is_stencil || layer.is_raised || layer.is_cutout) {
          if (layer.character_type.length === 0) {
            //if no character type is specified, show all
            return category.is_stencil;
          }
          return (
            category.is_stencil &&
            layer.character_type.indexOf(category.character_type) !== -1
          );
        }

        if (allowed_font_categories.length === 0) {
          //use the default categories
          return category.is_default;
        } else {
          return (
            allowed_font_categories.indexOf(parseInt(category.id, 10)) !== -1
          );
        }
      });

      fontCategoriesArray.push(filterFontCategories);
    });

    const categoryIdsToRemove = [];
    fontCategoriesArray.forEach((arr) => {
      for (var i = 0; i < arr.length; i++) {
        const containsId = fontCategoriesArray.some((el) => {
          return el.id === arr.id;
        });

        if (!containsId) {
          categoryIdsToRemove.push(arr.id);
        }
      }
    });

    const filteredCategories = categoryIdsToRemove.length
      ? fontCategoriesArray.filter((obj) => !categoryIdsToRemove.has(obj.id))
      : fontCategoriesArray[0];

    let selectedFont = {
      name: DefaultFont.NAME,
      id: DefaultFont.ID,
      size: 20,
    };

    if (this.props.latestFont) {
      selectedFont.name = this.props.latestFont.name;
      selectedFont.id = this.props.latestFont.id;
    } else if (this.props.firstTextElement) {
      selectedFont.name = this.props.firstTextElement.font.name;
      selectedFont.id = this.props.firstTextElement.font.id;
    }

    if (this.props.latestFontSize) {
      selectedFont.size = this.props.latestFontSize;
    } else if (this.props.firstTextElement) {
      selectedFont.size = this.props.firstTextElement.size;
    }

    return (
      <div className="tool tool--unify-text">
        <h4 className="tool__header">Text Style</h4>
        <div
          className="tool__option tool__option--unify-text"
          onClick={() => this.handleToggleUnifyText(selectedFont)}
        >
          <button
            className={`button button--border button--circle button--check ${active}`}
          >
            {this.props.unifyText && <CheckmarkIcon />}
          </button>
          <div className="button__text">
            Use same typeface &amp; size for all
          </div>
        </div>

        {this.props.unifyText && (
          <div className="tool__unify">
            <div className="tool__selectfont">
              <SelectTypeface
                allFonts={this.props.fonts.fonts}
                fontCategories={filteredCategories}
                font={selectedFont}
                selectedValue={selectedFont.id}
                handleFontChange={this.selectOption}
              />
            </div>

            {fontSizes && (
              <TextSize
                fontSize={selectedFont.size}
                allowedFontSizes={this.props.productOption.font_sizes}
                onUpdateSize={this.onUpdateSize}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    layers: state.design.present.layer_set,
    fonts: state.fonts,
    unifyText: state.unifyText.unifyText,
    latestFont: state.unifyText.latestFont,
    latestFontSize: state.unifyText.latestFontSize,
    productOption: state.productOption.entity,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      toggleUnifyText,
      setLatestFont,
      updateUnifiedFont,
      updateUnifiedFontSize,
      setLatestFontSize,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UnifyText);
